import React from 'react';
import { NavigationStepperItemType } from '../NavigationStepper';
import { NavigationStepperItemsProps } from '../NavigationStepperItems';
import TabNavigationStepperItem from './TabNavigationStepperItem';
// @ts-ignore
import styles from './TabNavigationStepperItems.module.scss';

const TabNavigationStepperItems: React.FC<
	NavigationStepperItemsProps
> = props => {
	const { items, onChange, activeKey } = props;

	return (
		<div className={styles.itemsWrapper}>
			<div className={styles.items}>
				{items.map((item: NavigationStepperItemType, index: number) => (
					<TabNavigationStepperItem
						item={item}
						key={index}
						onChange={onChange}
						activeKey={activeKey}
					/>
				))}
			</div>
		</div>
	);
};

export default TabNavigationStepperItems;
